var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PDFDocument } from 'pdf-lib';
import { MappingStorage } from '../../common/mapper/MappingStorage';
export function generateBasePdf(sobps) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const msi = MappingStorage.getInstance();
        let pdfDoc = undefined;
        let prevInkPagePdfUrl = null;
        let existingPdfBytes = null;
        let pdfDocSrc = null;
        pdfDoc = yield PDFDocument.create();
        for (const sobp of sobps) //병렬처리
         {
            const inkPageItem = msi.findPdfPage(sobp);
            const inkPagePdfUrl = (_a = inkPageItem === null || inkPageItem === void 0 ? void 0 : inkPageItem.pdf) === null || _a === void 0 ? void 0 : _a.url;
            const inkPagePdfPageNo = (_b = inkPageItem === null || inkPageItem === void 0 ? void 0 : inkPageItem.pageMapping) === null || _b === void 0 ? void 0 : _b.pdfPageNo;
            if (inkPagePdfUrl === undefined) {
                const pdfPage = yield pdfDoc.addPage();
                // if (page._rotation === 90 || page._rotation === 270) {
                //   const tmpWidth = pdfPage.getWidth();
                //   pdfPage.setWidth(pdfPage.getHeight());
                //   pdfPage.setHeight(tmpWidth);
                // }
            }
            else {
                //pdf인 경우
                if (prevInkPagePdfUrl !== inkPagePdfUrl) {
                    prevInkPagePdfUrl = inkPagePdfUrl;
                    existingPdfBytes = yield fetch(inkPagePdfUrl).then(res => res.arrayBuffer());
                    pdfDocSrc = yield PDFDocument.load(existingPdfBytes);
                    // /******************* pdfDoc에서 remove를 할경우
                    //  * pageCache에 값이 변하지 않아서 아래 getPages에서 기존의 개수가 그대로 나온다.
                    //  * pageCache는 원래 직접접근 하면 안되는 privite 이지만, 강제로 value를 업데이트 해준다
                    //  * 직접 접근 이외의 방법으로 업데이트가 가능하거나(현재 못찾음)
                    //  * pdf-lib가 업데이트 되어 필요없다면 삭제 필요
                    //  */
                    // (pdfDocSrc as any).pageCache.value = (pdfDocSrc as any).pageCache.populate();
                }
                /** 예전에 썼던 페이지 돌려쓰기 PDF에 맞도록 추가, 2021/11/21 */
                const srcNumPages = pdfDocSrc.getPageCount();
                const physicalPageNo = (inkPagePdfPageNo - 1) % srcNumPages;
                const copiedPages = yield pdfDoc.copyPages(pdfDocSrc, [physicalPageNo]);
                for (const copiedPage of copiedPages) {
                    pdfDoc.addPage(copiedPage);
                }
                // (pdfDocSrc as any).pageCache.value = (pdfDocSrc as any).pageCache.populate();
            }
        }
        return pdfDoc;
    });
}
//# sourceMappingURL=makePdfDocument.js.map